import React, { Fragment } from 'react'
import { DataBlock, H3, H2, List, ListItem, Card, Row, Button, Separator } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import Checkbox from '@fs/zion-ui/dist/cjs/checkbox'

const PersonElement = ({ persons }) => {
  const [t] = useTranslation()

  return (
    <>
      {persons.map((person) => {
        return (
          <Fragment key={person.id}>
            <Card>
              <List>
                <ListItem
                  startElement={<Checkbox name="personCheckbox" onChange={() => {}} />}
                  primaryText={<H3 size="H6">{person.name.fullName}</H3>}
                />
              </List>

              <Separator size="xxs" />
              <H2 size="H5">{t('aiindexing.events', 'Events')}</H2>
              {(!person?.events || person?.events?.length === 0) && (
                <>
                  {t('aiindexing.noEvent', 'No events')}
                  <Separator size="xs" />
                </>
              )}
              {person?.events?.length > 0 &&
                person?.events?.map((event) => (
                  <div key={event.eventType}>
                    <H3 size="H6">{event.eventType || event.type}</H3>
                    <Row>
                      <DataBlock heading={t('aiindexing.date', 'Date:')} data={event.date || ''} dense inline />
                      <br />
                      <DataBlock heading={t('aiindexing.place', 'Place:')} data={event.place || ''} dense inline />
                    </Row>
                    <Separator size="xs" />
                  </div>
                ))}

              <H2 size="H5">{t('aiindexing.relationships', 'Relationships')}</H2>
              {person?.relationships?.length === 0 && t('aiindexing.noRelationships', 'No relationships')}
              {person?.relationships?.length > 0 &&
                person?.relationships?.map((relationship) => (
                  <div key={relationship.eventType}>
                    <H3 size="H6">{relationship.eventType}</H3>
                    <Row>
                      <DataBlock
                        heading={t('aiindexing.relationshipName', 'Name:')}
                        data={relationship.name || ''}
                        dense
                        inline
                      />
                      <br />
                      <DataBlock
                        heading={t('aiindexing.relationshipType', 'Relationship Type:')}
                        data={relationship.relationshipType || ''}
                        dense
                        inline
                      />
                    </Row>
                    <Separator size="xs" />
                  </div>
                ))}
            </Card>
            <Separator size="xs" />
          </Fragment>
        )
      })}
      <Button
        size="small"
        emphasis="high"
        onClick={() => {
          // Handle action
        }}
      >
        {t('aiindexing.attach', 'Attach to Tree')}
      </Button>
    </>
  )
}

export default PersonElement
